<template lang="pug">
v-card(min-height="250px")
    v-card-title.justify-center(v-if="message.title") {{message.title}}
        v-icon.message-icon(v-if="message.icon" color="warning") {{message.icon}}
    v-card-text.text-body-1.black--text(v-html="message.text")
</template>

<script lang="ts">
import Vue from 'vue'
import {Component, Prop} from 'vue-property-decorator'
import {DashboardMessage} from '@/types'

@Component({})
export default class Message extends Vue {
  @Prop({type: Object, required: true}) message!: DashboardMessage
}

</script>

<style lang="stylus" scoped>
.message-icon
  position absolute
  left 20px
</style>
